export default __webpack_public_path__ + "6cc9f16a3846d2114c8185ebe5f85569.png";